import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import * as S from 'components/ArrivesBeforeHolidayBadge/ArrivesBeforeHolidayBadge.styles'
import { EVENT_NAMES } from 'services/Analytics/Analytics'
import type { Holiday } from 'services/HolidayService'
import type { CartItem } from 'stores/cartStore/CartItem'
import { useBagAnalytics } from '../../hooks/useBagAnalytics'

type ArrivesBeforeHolidayLineProps = {
  item: CartItem
  holiday: Holiday
}

function ArrivesBeforeHolidayLine({
  item,
  holiday,
}: ArrivesBeforeHolidayLineProps) {
  const { t } = useTranslation()
  const { trackBagItemEventOnce } = useBagAnalytics()

  useEffect(() => {
    trackBagItemEventOnce(
      EVENT_NAMES.CART_ARRIVES_BEFORE_HOLIDAY_SHOWN,
      `${item.id}:${holiday.id}`,
      item,
      { Holiday: holiday.id }
    )
  }, [holiday.id, item, trackBagItemEventOnce])

  return (
    <S.ArrivesBeforeHolidayBadge data-testid="cart-item-arrives-before-holiday">
      {t(holiday.cartLineTextKey)}
    </S.ArrivesBeforeHolidayBadge>
  )
}

export default ArrivesBeforeHolidayLine
